/**
 * 时间格式化
 * 1. 如果是当前输出：hh:mm
 * 2. 如果是昨天输出：昨天 hh:mm
 * 3. 其它输出：yyyy-MM-dd
 * @param {string|number} stamp
 * @returns {string}
 */
module.exports = function(stamp) {
  var millis = window.parseInt(stamp);
  millis = (millis > 1e12 ? millis : millis * 1e3);

  var EMPTY_SPACE = ' ';
  var ONE_DAY = 24 * 60 * 60 * 1e3;
  var d = new Date(millis);
  var year = d.getFullYear();
  var hours = d.getHours();
  var minutes = d.getMinutes();
  var day = d.getDay();
  var week = [
    '星期日',
    '星期一',
    '星期二',
    '星期三',
    '星期四',
    '星期五',
    '星期六'
  ][day] + EMPTY_SPACE;

  var date = d.getDate();
  var month = d.getMonth() + 1;
  month = (month > 9 ? '' : '0') + month;
  date = (date > 9 ? '' : '0') + date;

  var now = new Date();
  now.setHours(0);
  now.setMinutes(0);
  now.setSeconds(0);

  var todayMillis = now.getTime();
  var todayWeek = now.getDay();
  var yesterdayMillis = todayMillis - ONE_DAY;
  var yearMillis = (new Date(now.getFullYear().toString() + '/01/01 00:00:00')).getTime();
  var hourMinutes = [
    (hours < 10 ? '0' : '') + hours,
    (minutes < 10 ? '0' : '') + minutes
  ].join(':');
  var weekMillis;
  var formatStr = '';

  if (todayWeek !== 0) {
    weekMillis = todayMillis - ((todayWeek - 1) * ONE_DAY);
  } else {
    weekMillis = todayMillis - (6 * ONE_DAY);
  }

  if (millis >= todayMillis) {
    formatStr = hourMinutes;
  } else if (millis >= yesterdayMillis) {
    formatStr = '昨天 '+ hourMinutes;
  } else if (millis >= weekMillis) {
    formatStr = week + hourMinutes;
  } else if (millis >= yearMillis) {
    formatStr = month + '-'+  date + EMPTY_SPACE + hourMinutes;
  } else {
    formatStr = [year, month, date].join('-');
  }

  return formatStr;
};